import { GamificationApi, getHttpClient } from '@capsicum/common';

export const gamificationApi = getHttpClient.then(client => new GamificationApi(client));
